import {IconButton} from '@chakra-ui/react';
import React from 'react';
import {MdChevronLeft, MdChevronRight} from 'react-icons/md';
import {Carousel as ReactCarousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Carousel = ({
  autoPlay,
  children,
  centerMode = true,
  centerSlidePercentage = 100,
  renderArrowNext,
  renderArrowPrev,
  renderItem,
}) => (
  <ReactCarousel // https://github.com/leandrowd/react-responsive-carousel
    autoPlay={autoPlay}
    centerMode={centerMode}
    centerSlidePercentage={centerSlidePercentage}
    infiniteLoop
    interval={5000}
    preventMovementUntilSwipeScrollTolerance
    swipeScrollTolerance={50}
    renderItem={renderItem}
    showStatus={false}
    showThumbs={false}
    renderArrowNext={renderArrowNext}
    renderArrowPrev={renderArrowPrev}
  >
    {children}
  </ReactCarousel>
);

export default Carousel;
